import {
  formatAuditDate,
  getAuditActionLabel,
  getAuditPerformedBy,
  getAuditAffectedUser,
  getAuditDetailRows,
} from "../../../helpers/auditLogs";

export const ModalAuditLog = ({ log, onClose }) => {
  if (!log) return null;

  const detailRows = getAuditDetailRows(log);

  return (
    <div className="audit_logs_modal_backdrop" onClick={onClose}>
      <div className="audit_logs_modal" onClick={(e) => e.stopPropagation()}>
        <div className="audit_logs_modal_header">
          <h3>Detalle del cambio</h3>
          <button
            type="button"
            className="audit_logs_close_btn"
            onClick={onClose}
          >
            X
          </button>
        </div>

        <div className="audit_logs_modal_content">
          <div className="audit_logs_detail_top">
            <p>
              <strong>Fecha:</strong> {formatAuditDate(log.created_at)}
            </p>
            <p>
              <strong>Acción:</strong> {getAuditActionLabel(log.action)}
            </p>
            <p>
              <strong>Realizado por:</strong> {getAuditPerformedBy(log)}
            </p>
            <p>
              <strong>Usuario afectado:</strong> {getAuditAffectedUser(log)}
            </p>
          </div>

          {detailRows.length === 0 ? (
            <div className="audit_logs_empty_detail">
              No se detectaron cambios visibles para mostrar.
            </div>
          ) : (
            <div className="audit_logs_detail_table_wrapper">
              <table className="audit_logs_detail_table">
                <thead>
                  <tr>
                    <th>Campo</th>
                    <th>Antes</th>
                    <th>Ahora</th>
                  </tr>
                </thead>
                <tbody>
                  {detailRows.map((row) => (
                    <tr key={row.field}>
                      <td>{row.label}</td>
                      <td>{row.before}</td>
                      <td>{row.after}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
